/**
 *
 * Script accepts options object:
 * activeClass: accordion active header class - default value is "is-active"; type string,
 * visibleClass: accordion visible content block class - default value "is-visible"; type string,
 * headClass: accordion header selector - default value "accordion__item-head"; type string,
 * contentClass: accordion content block selector - default value "c-accordion__item-content"; type string,
 * withAnimation: option to show animation - default value false; type boolean
 * autoCollapse: option to automatically hide inactive content blocks - default value false; type boolean
 * closeActive: option allows you to close the active tab - default value true; type boolean
 *
 */

document.addEventListener('DOMContentLoaded', function () {
  const widgets = document.querySelectorAll('div[data-js-accordion]');

  if (widgets.length === 0) return null;

  let slideUp = (target, duration) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.style.overflow = 'hidden';

    window.setTimeout(() => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }

  let slideDown = (target, duration) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') {
      display = 'block';
    }
    target.style.display = display;

    let height = target.offsetHeight;
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.style.overflow = 'hidden';

    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');

    window.setTimeout(() => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }

  let slideToggle = (target, duration = 400) => {
    if (window.getComputedStyle(target).display === 'none') {
      return slideDown(target, duration);
    } else {
      return slideUp(target, duration);
    }
  }

  widgets.forEach(function (widget) {

    let activeClass = !widget.dataset['activeClass'] ? 'is-active' : widget.dataset['activeClass'],
      visibleClass = !widget.dataset['visibleClass'] ? 'is-visible' : widget.dataset['visibleClass'],
      headClass = !widget.dataset['headClass'] ? 'accordion__item-head' : widget.dataset['headClass'],
      contentClass = !widget.dataset['contentClass'] ? 'accordion__item-content' : widget.dataset['contentClass'],
      withAnimation = typeof widget.dataset['animation'] !== 'undefined',
      autoCollapse = typeof widget.dataset['collapse'] !== 'undefined',
      closeActive = typeof widget.dataset['activeClose'] !== 'undefined',
      activeIndex = 0;

    const heads = widget.querySelectorAll('.' + headClass),
      contents = widget.querySelectorAll('.' + contentClass),
      hash = window.location.hash ? window.location.hash.replace("#", '') : null;

    contents.forEach(function (element) {
      const tables = element.querySelectorAll('table');
      if (tables.length > 0) {
        tables.forEach(function (table) {
          const wrapper = document.createElement('div'),
            parent = table.previousElementSibling;
          wrapper.classList.add('table-scrollable');
          wrapper.append(table);
          if (parent) {
            parent.insertAdjacentElement('afterend', wrapper);
          }
        });
      }
    });

    if (hash) {
      let targetSearch = hash.replaceAll('-', ' ');
      heads.forEach(function (head, index) {

        head.classList.remove(activeClass);
        contents[index].classList.remove(visibleClass);

        let searchString = head.textContent.trim().toLowerCase();
        if (searchString.includes(targetSearch)) {
          activeIndex = index;
        }
      });

      heads[activeIndex].classList.add(activeClass);
      contents[activeIndex].classList.add(visibleClass);

      let headerHeight = document.querySelector('.header-wrapper').offsetHeight;
      window.scrollTo({top: heads[activeIndex].offsetTop - headerHeight, behavior: 'smooth'});

    }

    heads.forEach(function (head, index) {
      head.addEventListener('click', function (event) {
        event.preventDefault();

        let thisHead = head,
          thisContent = head.nextElementSibling;

        function animateToggle() {
          if (closeActive && !autoCollapse) {
            slideToggle(thisContent, 400);
            thisContent.classList.toggle(visibleClass);
          } else if (!closeActive && !autoCollapse) {
            slideDown(thisContent, 400);
            thisContent.classList.add(visibleClass);
          } else if (!closeActive && autoCollapse) {
            slideDown(thisContent, 400);
            contents.forEach(function (content) {
            });
            thisContent.classList.add(visibleClass);
            slideUp(widget.querySelector('.' + contentClass + ':not(' + '.' + contentClass + '.' + '.' + visibleClass + ')'), 400);
          } else if (closeActive && autoCollapse) {
            if (!thisContent.classList.contains(visibleClass)) {
              slideDown(thisContent, 400);
              contents.forEach(function (content) {
              });
              thisContent.classList.add(visibleClass);
              slideUp(widget.querySelector('.' + contentClass + ':not(' + '.' + contentClass + '.' + visibleClass + ')'), 400);
            } else {
              if (thisContent.classList.contains(visibleClass)) {
                slideUp(thisContent, 400);
                thisContent.classList.remove(visibleClass);
              } else {
                slideDown(thisContent, 400);
                thisContent.classList.add(visibleClass);
              }
            }
          }
        }

        function toggleHead() {
          if (autoCollapse && !closeActive) {
            heads.forEach(function (head) {
              head.classList.remove(activeClass)
            });
            thisHead.classList.add(activeClass);
            thisHead.children[0].classList.add(activeClass);
          } else if (!autoCollapse && !closeActive) {
            thisHead.classList.add(activeClass);
            thisHead.children[0].classList.add(activeClass);
          } else if (!autoCollapse && closeActive) {
            thisHead.classList.toggle(activeClass);
          } else if (autoCollapse && closeActive) {
            heads.forEach(function (head) {
              head.classList.remove(activeClass)
            });
            if (thisContent.classList.contains(visibleClass)) {
              thisHead.classList.add(activeClass);
              thisHead.children[0].classList.add(activeClass);
            } else {
              thisHead.classList.remove(activeClass);
              thisHead.children[0].classList.remove(activeClass);
            }
          }
        }

        function withoutAnimateToggle() {
          if (closeActive && !autoCollapse) {
            thisContent.classList.toggle(visibleClass);
          } else if (!closeActive && !autoCollapse) {
            thisContent.classList.add(visibleClass);
          } else if (!closeActive && autoCollapse) {
            contents.forEach(function (content) {
            });
            thisContent.classList.add(visibleClass);
          } else if (closeActive && autoCollapse) {
            if (!thisContent.classList.contains(visibleClass)) {
              contents.forEach(function (content) {
              });
              thisContent.classList.add(visibleClass);
            } else {
              if (thisContent.classList.contains(visibleClass)) {
                thisContent.classList.remove(visibleClass);
              } else {
                thisContent.classList.add(visibleClass);
              }
            }
          }
        }

        if (withAnimation) {
          animateToggle();
        } else {
          withoutAnimateToggle();
        }
        toggleHead();

        if (thisHead.classList.contains(activeClass)) {
          let headerHeight = document.querySelector('.header-wrapper').offsetHeight;
          window.scrollTo({top: thisHead.offsetTop - headerHeight, behavior: 'smooth'});
        }
      });
    });
  });
});
